import React from 'react';

export const StorePodBadge = () => {
  return (
    <span className="sui-bg-medium sui-text-inverse sui-text-xs sui-px-1 sui-py-1px" data-component="StorePodBadge">
      My Store
    </span>
  );
};

StorePodBadge.displayName = 'StorePodBadge';
